"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = makeStyles_1.default(() => ({
    root: {
        padding: 2,
        minWidth: 'auto',
    },
    outlined: {
        fontWeight: 'normal',
        textTransform: 'none',
    },
}));
//# sourceMappingURL=button-styles.js.map